import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from 'react-native'
import { Txt } from '../../../../components'
import { getMonthWeekDayFormat } from '../../../../tools/dataParse'
import { useTheme } from '../../../../theming/ThemeProvider'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import Identity from '../../../../utils/Identity'
import { getPaymentStatusColor } from '../../../../tools/objectMapValues'
import useStyles from '../../../../components/Cards/useStyles'

const InvoiceCard = ({ item }) => {
  const { isTablet, isDesktop } = usePlatforms()
  const { theme } = useTheme()
  const styles = {
    ...useStyles(theme, isTablet, isDesktop),
    ...useLocalStyles(isTablet)
  }
  const {
    UploadedDate, NetAmount, ScheduledPaymentDate, ActualPaidDate,
    InvoiceStatusId, InvoiceStatusName, InvoiceNo, ReferenceNo
  } = item
  const stateColor = getPaymentStatusColor(InvoiceStatusId)

  const Status = useMemo(() => (
    <View style={[styles.status, { backgroundColor: theme[stateColor] }]}>
      <Txt
        text={InvoiceStatusName}
        color='WHITE'
        identity='body3Bold'

      />
    </View>
  ), [InvoiceStatusName, stateColor, styles.status, theme])
  return (
    <View style={[styles.cardStyle, Identity.Shadow(theme).Card]}>
      {isTablet && Status}
      <View style={{ flex: 1, flexDirection: isTablet ? 'row' : 'column', flexWrap: 'wrap' }}>
        <View style={styles.firstRow}>
          <View style={styles.item}>
            <Txt
              color='SLATE_GRAY'
              identity='body1Bold'
              text={InvoiceNo || '--'}
            />
            <Txt
              color='SLATE_GRAY'
              text='Invoice #'
              identity='body3'
            />
          </View>
          <View style={[styles.item, styles.number]}>
            <Txt
              color='SLATE_GRAY'
              identity='body1Bold'
              text={ReferenceNo || '--'}
            />
            <Txt
              color='SLATE_GRAY'
              text='Reference #'
              identity='body3'
            />
          </View>
          {!isTablet && (
            <View style={styles.item}>
              {Status}
            </View>
          )}
        </View>
        <View style={styles.secondRow}>
          <View style={styles.item}>
            <Txt
              color='SLATE_GRAY'
              identity='body1Bold'
              text={UploadedDate ? getMonthWeekDayFormat(UploadedDate) : '--'}
            />
            <Txt
              color='SLATE_GRAY'
              text='Upload Date'
              identity='body3'
            />
          </View>
          <View style={[styles.item, styles.number]}>
            <Txt
              color='SLATE_GRAY'
              identity='body1Bold'
              text={
                ActualPaidDate
                  ? getMonthWeekDayFormat(ActualPaidDate)
                  : ScheduledPaymentDate
                    ? getMonthWeekDayFormat(ScheduledPaymentDate)
                    : '--'
              }
            />
            <Txt
              color='SLATE_GRAY'
              text='Pay Date'
              identity='body3'
            />
          </View>
          <View style={styles.item}>
            <Txt
              color='FERN'
              identity='body2Bold'
              text={`$ ${NetAmount || '--'} USD`}
              style={styles.rightText}
            />
            <Txt
              color='SLATE_GRAY'
              text='Net Amount Due'
              identity='body3'
              style={styles.rightText}
            />
          </View>
        </View>
      </View>
      {!isTablet && <View style={[styles.marked, { backgroundColor: theme[stateColor] }]} />}

    </View>
  )
}

const useLocalStyles = (isTablet) => StyleSheet.create({
  firstRow: {
    flex: 1,
    width: isTablet ? 'auto' : '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: isTablet ? 0 : 20,
    marginTop: isTablet ? 10 : 0
  },
  secondRow: {
    flex: isTablet ? 2 : 1,
    flexDirection: 'row',
    justifyContent: isTablet ? 'space-around' : 'space-between',
    alignItems: 'center',
    width: isTablet ? 'auto' : '100%',
    marginLeft: isTablet ? 50 : 0,
    marginTop: isTablet ? 10 : 0
  },
  item: {
    width: 100
  },
  rightText: {
    textAlign: isTablet ? 'left' : 'right'
  },
  number: {
    marginLeft: 30
  }
})

InvoiceCard.propTypes = {
  item: PropTypes.object.isRequired
}

export default InvoiceCard
